
import axios from "axios"; 

const RosterAttendanceService = {
  async getByDate(date) {
    try {
      const response = await axios.get(
        `/UserDetails/GetRandNdata?today=${date}`
        //`https://daladamaligawa.dockyardsoftware.com/UserDetails/GetAttendenceByRoster?today=${date}`
      );

      console.log("Roster Attendance API response:", response.data);
      
      if (response.data && Array.isArray(response.data.resultSet)) {
        // Transform the API response to match component's expected format
        return response.data.resultSet.map(item => ({
          location: item.location,
          TotalEmp: item.TotalEmp,
          TodayAtt: item.TodayAtt,
          Percentage: item.Percentage,
          Roster: item.Roster || "N", // Default to "N" if not provided
        }));
      } else {
        console.warn("Unexpected API response structure:", response.data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching roster attendance data:", error);
      throw error;
    }
  },

  async getFullAbsentDetailsForRoster(date) {
    try {
      const response = await axios.get(
        `/UserDetails/GetAbsentDetailsAll?today=${date}`
      );

      console.log("Full Roster Absent Details API response:", response.data);
      
      if (response.data && Array.isArray(response.data.resultSet)) {
        return response.data.resultSet;
      } else {
        console.warn("Unexpected API response structure:", response.data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching full roster absent details data:", error);
      throw error;
    }
  },

  // Get ABSENT employee list for a specific location
  async getAbsentEmployeesByLocation(date, locationCode) {
    try {
      if (!locationCode) {
        console.warn("No location code provided");
        return [];
      }
      
      // This endpoint returns ONLY absent employees for a location
      const url = `/UserDetails/GetAbsentDetailsForDaywithL?today=${date}&location=${locationCode}`;
      console.log("Fetching absent employees:", url);
      
      const response = await axios.get(url);
      console.log("Absent employees response:", response.data);
      
      let resultData = [];
      if (response.data && response.data.statusCode === 200 && Array.isArray(response.data.resultSet)) {
        resultData = response.data.resultSet;
      } else if (response.data && Array.isArray(response.data.resultSet)) {
        resultData = response.data.resultSet;
      } else if (response.data && Array.isArray(response.data.ResultSet)) {
        resultData = response.data.ResultSet;
      }
      
      console.log("Absent employees returned:", resultData.length);
      if (resultData.length > 0) {
        console.log("Sample absent employee:", JSON.stringify(resultData[0]));
        console.log("Available fields:", Object.keys(resultData[0]));
      }
      
      return resultData;
    } catch (error) {
      console.error("Error fetching absent employees:", error);
      return [];
    }
  },

  // Get employee-level absent details for a specific location and roster type
  async getAbsentDetailsForRoster(date, location = '', rosterType = '') {
    try {
      if (!location) {
        console.warn("No location provided for employee details");
        return [];
      }
      
      // Try the roster-specific endpoint first
      let url = `/UserDetails/GetAbsentDetailsForRoster?today=${date}&location=${location}`;
      if (rosterType) {
        url += `&roster=${encodeURIComponent(rosterType)}`;
      }
      
      console.log("Calling roster employee API:", url);
      const response = await axios.get(url);
      console.log("Roster Employee API response:", response.data);
      
      let resultData = [];
      if (response.data && response.data.statusCode === 200 && Array.isArray(response.data.resultSet)) {
        resultData = response.data.resultSet;
      } else if (response.data && Array.isArray(response.data.resultSet)) {
        resultData = response.data.resultSet;
      }
      
      console.log("Roster endpoint returned", resultData.length, "employees");
      if (resultData.length > 0) {
        console.log("Sample employee:", JSON.stringify(resultData[0]));
        console.log("Available fields:", Object.keys(resultData[0]));
        return resultData;
      }
      
      // Fallback: try the generic absent details endpoint
      console.log("Roster endpoint returned 0 results, trying fallback GetAbsentDetailsForDaywithL");
      const url2 = `/UserDetails/GetAbsentDetailsForDaywithL?today=${date}&location=${location}`;
      const response2 = await axios.get(url2);
      console.log("Fallback API response:", response2.data);
      
      if (response2.data && response2.data.statusCode === 200 && Array.isArray(response2.data.resultSet)) {
        const fallbackData = response2.data.resultSet;
        console.log("Fallback returned", fallbackData.length, "employees");
        if (fallbackData.length > 0) {
          console.log("Fallback sample:", JSON.stringify(fallbackData[0]));
        }
        return fallbackData;
      }
      
      if (response2.data && Array.isArray(response2.data.resultSet)) {
        return response2.data.resultSet;
      }
      
      return [];
    } catch (error) {
      console.error("Error fetching employee absent details:", error);
      return [];
    }
  }
};

export default RosterAttendanceService;


// import axios from "axios"; 

// const RosterAttendanceService = {
//   async getByDate(date) {
//     try {
//       const response = await axios.get(
//         `https://daladamaligawa.dockyardsoftware.com/UserDetails/GetRandNdata?today=${date}`
//         //`https://daladamaligawa.dockyardsoftware.com/UserDetails/GetAttendenceByRoster?today=${date}`
//       );

//       console.log("Roster Attendance API response:", response.data);
      
//       if (response.data && Array.isArray(response.data.resultSet)) {
//         // Transform the API response to match component's expected format
//         return response.data.resultSet.map(item => ({
//           location: item.location,
//           TotalEmp: item.TotalEmp,
//           TodayAtt: item.TodayAtt,
//           Percentage: item.Percentage,
//           Roster: item.Roster || "N", // Default to "N" if not provided
//         }));
//       } else {
//         console.warn("Unexpected API response structure:", response.data);
//         return [];
//       }
//     } catch (error) {
//       console.error("Error fetching roster attendance data:", error);
//       throw error;
//     }
//   },

//   async getFullAbsentDetailsForRoster(date) {
//     try {
//       const response = await axios.get(
//         //`https://daladamaligawa.dockyardsoftware.com/UserDetails/GetFullAbsentDetailsForRoster?today=${date}`
//         `https://daladamaligawa.dockyardsoftware.com/UserDetails/GetFullAbsentDetailsAll?today=${date}`
//       );

//       console.log("Full Roster Absent Details API response:", response.data);
      
//       if (response.data && Array.isArray(response.data.resultSet)) {
//         return response.data.resultSet;
//       } else {
//         console.warn("Unexpected API response structure:", response.data);
//         return [];
//       }
//     } catch (error) {
//       console.error("Error fetching full roster absent details data:", error);
//       throw error;
//     }
//   },

//   // Add this new method for getting absent details with location filter
//   async getAbsentDetailsForRoster(date, location = '') {
//     try {
//       // This is a placeholder - adjust the endpoint as per your actual API
//       const url = location 
//         ? `https://daladamaligawa.dockyardsoftware.com/UserDetails/GetAbsentDetailsForRoster?today=${date}&location=${location}`
//         : `https://daladamaligawa.dockyardsoftware.com/UserDetails/GetAbsentDetailsForRoster?today=${date}`;
      
//       const response = await axios.get(url);
      
//       console.log("Absent Details API response:", response.data);
      
//       if (response.data && Array.isArray(response.data.resultSet)) {
//         return response.data.resultSet;
//       } else {
//         console.warn("Unexpected API response structure:", response.data);
//         return [];
//       }
//     } catch (error) {
//       console.error("Error fetching absent details data:", error);
//       throw error;
//     }
//   }
// };

// export default RosterAttendanceService;



// import axios from "axios"; 

// const API_BASE_URL = "https://daladamaligawa.dockyardsoftware.com";

// const RosterAttendanceService = {
//   // Get roster attendance summary (for Total Strength card)
//   async getByDate(date) {
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/UserDetails/GetRandNdata?today=${date}`
//       );

//       console.log("Roster Attendance API response:", response.data);
      
//       if (response.data && Array.isArray(response.data.resultSet)) {
//         return response.data.resultSet.map(item => ({
//           location: item.location,
//           TotalEmp: item.TotalEmp,
//           TodayAtt: item.TodayAtt,
//           Percentage: item.Percentage,
//           Roster: item.Roster || "N",
//         }));
//       } else {
//         console.warn("Unexpected API response structure:", response.data);
//         return [];
//       }
//     } catch (error) {
//       console.error("Error fetching roster attendance data:", error);
//       throw error;
//     }
//   },

//   // Get absent summary by location (for Total Absent card and table)
//   async getAbsentDetailsAll(date) {
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/UserDetails/GetAbsentDetailsAll?today=${date}`
//       );

//       console.log("Absent Details All API response:", response.data);
      
//       if (response.data && Array.isArray(response.data.resultSet)) {
//         return response.data.resultSet;
//       } else {
//         console.warn("Unexpected API response structure:", response.data);
//         return [];
//       }
//     } catch (error) {
//       console.error("Error fetching absent details all data:", error);
//       throw error;
//     }
//   },

//   // Get employee-level absent details for a specific location
//   async getAbsentDetailsForRoster(date, locationCode) {
//     try {
//       // Try the main endpoint first
//       const response = await axios.get(
//         `${API_BASE_URL}/UserDetails/GetAbsentDetailsForRoster?today=${date}&location=${locationCode}`
//       );
      
//       console.log("Employee Absent Details API response:", response.data);
      
//       if (response.data && Array.isArray(response.data.resultSet)) {
//         return response.data.resultSet;
//       } else {
//         console.warn("Unexpected API response structure:", response.data);
//         return [];
//       }
//     } catch (error) {
//       console.error("Error fetching employee absent details:", error);
//       // Return empty array instead of throwing to prevent UI breaking
//       return [];
//     }
//   }
// };

// export default RosterAttendanceService;